import { useQuery } from '@tanstack/react-query';
import { http } from '@/lib/api/http';
import type { ModuleKey, NavItem } from './nav';

export type BusinessProfile = 'SERVICES' | 'DISTRIBUTION' | 'INDUSTRY' | 'RETAIL' | 'FULL' | 'CUSTOM';
export interface ProfileView { profile: BusinessProfile | null; modules: ModuleKey[]; profiles: Record<Exclude<BusinessProfile, 'CUSTOM'>, ModuleKey[]>; allModules: ModuleKey[]; rowVersion: number | null }

export const useProfile = () =>
  useQuery({ queryKey: ['onboarding', 'profile'], queryFn: () => http.get<ProfileView>('/onboarding/profile'), staleTime: 5 * 60_000 });

/** Whether a menu entry belongs to a module the company's profile shows. Until the profile is loaded everything is shown. */
export function useModuleFilter() {
  const q = useProfile();
  const on = q.data ? new Set(q.data.modules) : null;
  return (i: NavItem) => !i.module || !on || on.has(i.module);
}
